import { render, staticRenderFns } from "./sys_message.vue?vue&type=template&id=dc5e2938&scoped=true&"
import script from "./sys_message.vue?vue&type=script&lang=js&"
export * from "./sys_message.vue?vue&type=script&lang=js&"
import style0 from "./sys_message.vue?vue&type=style&index=0&id=dc5e2938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5e2938",
  null
  
)

export default component.exports